import styles from "./Arrow.module.css";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const Arrow = ({ arrowDirection = "", onClick, style = {} }) => {
  const isArrowDirectionLeft = arrowDirection === "left";
  return (
    <button
      aria-label={`${arrowDirection} arrow`}
      className={styles["arrow"]}
      style={{
        [arrowDirection]: "5px",
        ...style,
      }}
      onClick={() => onClick(arrowDirection)}
    >
      {isArrowDirectionLeft ? (
        <MdKeyboardArrowLeft className={styles.icon} />
      ) : (
        <MdKeyboardArrowRight className={styles.icon} />
      )}
    </button>
  );
};

export default Arrow;
